import React, { FC } from 'react';
import { View } from 'react-native';
import Modal from 'react-native-modal';

import { fullHeight, webHeader } from '@components/frame';
import { isWeb } from '@helpers';
import { WithColor } from '@styles/colors';
import AnimatedBottomSheet from '@components/common/ScreenAnimations/components/BottomSheet';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';
import NCFileDiffView from '@components/ncFileVersions/components/NCFileDiffView';
import { NCFileDiffViewProps } from '@components/ncFileVersions/components/NCFileDiffView/types';

export interface NCFileDiffSheetProps
  extends WithColor,
    Partial<Pick<NCFileDiffViewProps, 'oldVersionData' | 'newVersionData' | 'getNCFile' | 'availableVersions' | 'onReplaceVersion' | 'onToggleFavoriteVersion' | 'ncFileName'>> {
  visible: boolean;
  onClose: () => void;
  webTopOffset?: number;
}

// Tiny shell wrapping NCFileDiffView in the web bottom-sheet / native modal; owns no comparison/loading/error logic.
const NCFileDiffSheet: FC<NCFileDiffSheetProps> = ({
  C,
  visible,
  oldVersionData,
  newVersionData,
  getNCFile,
  availableVersions,
  onReplaceVersion,
  onToggleFavoriteVersion,
  onClose,
  ncFileName,
  webTopOffset = webHeader,
}) => {
  if (!visible || !oldVersionData || !newVersionData || !getNCFile) {
    return null;
  }

  const diffView = (
    <View testID={TEST_IDS.ncFileVersions.comparisonSheet} style={{ flex: 1, backgroundColor: C('Background/Light/Detail') }}>
      <NCFileDiffView
        C={C}
        oldVersionData={oldVersionData}
        newVersionData={newVersionData}
        getNCFile={getNCFile}
        availableVersions={availableVersions ?? []}
        onReplaceVersion={onReplaceVersion}
        onClose={onClose}
        ncFileName={ncFileName}
        onToggleFavoriteVersion={onToggleFavoriteVersion}
      />
    </View>
  );

  if (isWeb) {
    return (
      <AnimatedBottomSheet onPresentedChange={onClose} containerStyle={{ height: fullHeight - webTopOffset, marginTop: webTopOffset }} handleScroll={true}>
        {diffView}
      </AnimatedBottomSheet>
    );
  }

  return (
    <Modal isVisible={visible} onBackdropPress={onClose} onBackButtonPress={onClose} style={{ margin: 0 }} animationIn="slideInUp" animationOut="slideOutDown">
      {diffView}
    </Modal>
  );
};

export default NCFileDiffSheet;
